"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookTemplateThumbnailGalleryStyles = exports.WorkbookTemplateWidgetsInteractiveViz = exports.WorkbookTemplateWidgetsTabStyles = exports.WorkbookTemplateWidgetsProjectPickerStyles = exports.WorkbookTemplateWidgetsStyles = exports.cssClass = void 0;
var widgets_1 = require("@tableau/widgets");
var typestyle_1 = require("typestyle");
var cssPrefix = 'starters';
function cssClass(prefix, name) {
    var styles = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        styles[_i - 2] = arguments[_i];
    }
    return typestyle_1.style.apply(void 0, __spreadArray(__spreadArray([], styles, false), [{
            $debugName: prefix + "_" + name,
            $unique: true,
        }], false));
}
exports.cssClass = cssClass;
var WorkbookTemplateWidgetsStyles;
(function (WorkbookTemplateWidgetsStyles) {
    // Image width and height as per visual design specs
    WorkbookTemplateWidgetsStyles.LargeThumbnailImageHeight = 363;
    WorkbookTemplateWidgetsStyles.LargeThumbnailImageWidth = 600;
    WorkbookTemplateWidgetsStyles.TemplateItemDiv = cssClass(cssPrefix, 'template-item-div', {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        overflowX: 'auto',
        overflowY: 'hidden',
        height: WorkbookTemplateWidgetsStyles.LargeThumbnailImageHeight + 3 + 'px',
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        marginRight: widgets_1.TabStyles.Spacing.LargeSpace,
    });
    WorkbookTemplateWidgetsStyles.ImageDiv = cssClass(cssPrefix, 'image-div', {
        width: WorkbookTemplateWidgetsStyles.LargeThumbnailImageWidth + 'px',
        minWidth: WorkbookTemplateWidgetsStyles.LargeThumbnailImageWidth + 'px',
        height: WorkbookTemplateWidgetsStyles.LargeThumbnailImageHeight + 'px',
        marginRight: widgets_1.TabStyles.Spacing.LargeSpace,
    });
    WorkbookTemplateWidgetsStyles.TemplateItemDescriptionDiv = cssClass(cssPrefix, 'description-div', {
        marginLeft: widgets_1.TabStyles.Spacing.LargeSpace,
        marginRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 1 200px',
    });
    WorkbookTemplateWidgetsStyles.TemplateItemTitle = cssClass(cssPrefix, 'template-item-title', {
        fontWeight: 'bolder',
        marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
        marginTop: widgets_1.TabStyles.Spacing.DefaultSpace,
    });
    WorkbookTemplateWidgetsStyles.TemplateItemDescriptionText = cssClass(cssPrefix, 'template-item-description-item', {
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        overflowY: 'hidden',
    });
    WorkbookTemplateWidgetsStyles.AvailableLayouts = cssClass(cssPrefix, 'available-layouts', {
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
    });
    WorkbookTemplateWidgetsStyles.ConnectionType = cssClass(cssPrefix, 'connection-type', {
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
        fontWeight: 'bold',
    });
    WorkbookTemplateWidgetsStyles.ConnectionTypeSmallDescription = cssClass(cssPrefix, 'connection-type', {
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
        fontSize: '14px',
        fontWeight: 'bold',
    });
    WorkbookTemplateWidgetsStyles.ButtonDiv = cssClass(cssPrefix, 'button-div', {
        marginTop: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    });
    WorkbookTemplateWidgetsStyles.CreateExtractWaitingDialog = cssClass(cssPrefix, 'create-extract-waiting-dialog', {
        marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
    });
    WorkbookTemplateWidgetsStyles.TemplateThumbnailGalleryDiv = cssClass(cssPrefix, 'template-item-thumbnail-gallery', {
        display: 'flex',
        flex: '1',
        flexDirection: 'row',
        flexWrap: 'wrap',
    });
    WorkbookTemplateWidgetsStyles.UseSampleDataButton = cssClass(cssPrefix, 'template-item-use-sample-data-button', {
        marginRight: '12px',
        marginBottom: '6px',
    });
})(WorkbookTemplateWidgetsStyles = exports.WorkbookTemplateWidgetsStyles || (exports.WorkbookTemplateWidgetsStyles = {}));
var WorkbookTemplateWidgetsProjectPickerStyles;
(function (WorkbookTemplateWidgetsProjectPickerStyles) {
    WorkbookTemplateWidgetsProjectPickerStyles.inputFullWidth = cssClass(cssPrefix, 'input-full-width', {
        flex: '1',
        width: '100%',
    });
    WorkbookTemplateWidgetsProjectPickerStyles.projectSelector = cssClass(cssPrefix, 'project-selector', {
        marginTop: '12px',
    });
    WorkbookTemplateWidgetsProjectPickerStyles.projectPicker = cssClass(cssPrefix, 'project-picker', {
        marginTop: '6px',
    });
    WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerContainerDiv = cssClass(cssPrefix, 'project-picker-container-div', {
        position: 'relative',
        height: 250,
        width: '100%',
    });
    WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerDiv = cssClass(cssPrefix, 'project-picker-div', {
        position: 'relative',
        height: '100%',
        padding: 1,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: widgets_1.TabStyles.Colors.L4,
    });
    WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerDialog = cssClass(cssPrefix, 'project-picker-dialog', {
        marginBottom: '10px',
    });
})(WorkbookTemplateWidgetsProjectPickerStyles = exports.WorkbookTemplateWidgetsProjectPickerStyles || (exports.WorkbookTemplateWidgetsProjectPickerStyles = {}));
var WorkbookTemplateWidgetsTabStyles;
(function (WorkbookTemplateWidgetsTabStyles) {
    var HorizontalTitleBarHeight = 30;
    WorkbookTemplateWidgetsTabStyles.ContainerDiv = cssClass(cssPrefix, 'workbook-template-tab-container-div', {
        // this combination ensures that scrolling works correctly on chrome, firefox, edge:
        // firefox and edge require 'absolute' for scrolling to work.
        // chrome requires width, height percentages with absolute in order to display correctly
        position: 'absolute',
        height: '100%',
        width: '100%',
    });
    WorkbookTemplateWidgetsTabStyles.HorizontalTittleBar = cssClass(cssPrefix, 'workbook-template-tab-horizontal-title-bar', {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: widgets_1.TabStyles.Spacing.DefaultSpace,
    });
    WorkbookTemplateWidgetsTabStyles.HorizontalTitleTextDiv = cssClass(cssPrefix, 'workbook-template-tab-HorizontalTitleTextDiv', {
        paddingTop: widgets_1.TabStyles.Spacing.SmallSpace,
        marginRight: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    });
    WorkbookTemplateWidgetsTabStyles.HorizontalTitleDropdownDiv = cssClass(cssPrefix, 'workbook-template-tab-horizontal-dropdown-div', {
        // Disallow dropdown div to change size to avoid that it gets squashed by text div to its left
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 'auto',
    });
    WorkbookTemplateWidgetsTabStyles.HorizontalScrollDiv = cssClass(cssPrefix, 'workbook-template-tab-horizontal-scroll-div', {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        overflowX: 'hidden',
        height: "Calc(100% - " + HorizontalTitleBarHeight + "px)",
        marginBottom: widgets_1.TabStyles.Spacing.LargeSpace,
    });
    WorkbookTemplateWidgetsTabStyles.HorizontalLine = cssClass(cssPrefix, 'workbook-template-tab-horizontal-line', {
        marginRight: widgets_1.TabStyles.Spacing.LargeSpace,
        border: 'none',
        borderTop: widgets_1.TabStyles.Sizing.BorderWidth + 'px solid ' + widgets_1.TabStyles.Colors.L4,
    });
})(WorkbookTemplateWidgetsTabStyles = exports.WorkbookTemplateWidgetsTabStyles || (exports.WorkbookTemplateWidgetsTabStyles = {}));
var WorkbookTemplateWidgetsInteractiveViz;
(function (WorkbookTemplateWidgetsInteractiveViz) {
    WorkbookTemplateWidgetsInteractiveViz.InteractiveIframe = cssClass(cssPrefix, 'interactive-iframe', {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        height: '100%',
    });
    function getDesiredDeviceType() {
        if (window.innerWidth * 0.9 < 500) {
            return 'mobile';
        }
        return 'desktop';
    }
    WorkbookTemplateWidgetsInteractiveViz.getDesiredDeviceType = getDesiredDeviceType;
})(WorkbookTemplateWidgetsInteractiveViz = exports.WorkbookTemplateWidgetsInteractiveViz || (exports.WorkbookTemplateWidgetsInteractiveViz = {}));
var WorkbookTemplateThumbnailGalleryStyles;
(function (WorkbookTemplateThumbnailGalleryStyles) {
    WorkbookTemplateThumbnailGalleryStyles.ThumbnailGalleryItemStyle = cssClass(cssPrefix, 'thumbnail-gallery-item', {
        opacity: 0.6,
        $nest: {
            '&:hover': {
                opacity: 1,
                zIndex: 3,
            },
        },
        height: '100%',
        width: '100%',
        border: '1px solid #cbcbcb',
    });
    WorkbookTemplateThumbnailGalleryStyles.ThumbnailGalleryItemSelectedStyle = cssClass(cssPrefix, 'thumbnail-gallery-item-selected', {
        border: '1px solid #3498DB',
        borderBottomColor: 'black',
        borderColor: 'rgba(203, 203, 203)',
        borderRadius: '1px',
        boxShadow: "0 0 4px 0 #3498DB",
        height: '100%',
        width: '100%',
    });
    WorkbookTemplateThumbnailGalleryStyles.ThumbnailGalleryItemContainer = cssClass(cssPrefix, 'thumbnail-gallery-item-container', {
        display: 'flex',
        flex: '0 1 22%',
        flexWrap: 'wrap',
        marginBottom: '16px',
        width: '100%',
        maxWidth: '150px',
        marginRight: '8px',
        marginLeft: '8px',
    });
})(WorkbookTemplateThumbnailGalleryStyles = exports.WorkbookTemplateThumbnailGalleryStyles || (exports.WorkbookTemplateThumbnailGalleryStyles = {}));
//# sourceMappingURL=WorkbookTemplateWidgetsStyles.js.map